export default __webpack_public_path__ + "static/media/pdfIcon.5c591265.svg";